const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const key = localStorage.getItem('bah_cms_key');
  return key ? { Authorization: `Bearer ${key}` } : {};
};

const request = async (path, options = {}) => {
  if (!API_URL) throw new Error('REACT_APP_API_URL is not set. Copy .env.example to .env and set the API URL.');
  const res = await fetch(`${API_URL}${path}`, options);
  if (!res.ok) {
    const err = new Error(`API error: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  return res.json();
};

// Upload
export const getUploadUrl = (key, contentType) => request('/upload', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify({ key, contentType }) });

// Events
export const listEvents = () => request('/events');
export const getEvent = (id) => request(`/events/${id}`);
export const createEvent = (data) => request('/events', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const updateEvent = (id, data) => request(`/events/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const deleteEvent = (id) => request(`/events/${id}`, { method: 'DELETE', headers: getAuthHeaders() });

// Posts
export const listPosts = () => request('/posts');
export const getPost = (id) => request(`/posts/${id}`);
export const createPost = (data) => request('/posts', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const updatePost = (id, data) => request(`/posts/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const deletePost = (id) => request(`/posts/${id}`, { method: 'DELETE', headers: getAuthHeaders() });

// Team Members
export const listTeamMembers = () => request('/team-members');
export const getTeamMember = (id) => request(`/team-members/${id}`);
export const createTeamMember = (data) => request('/team-members', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const updateTeamMember = (id, data) => request(`/team-members/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const deleteTeamMember = (id) => request(`/team-members/${id}`, { method: 'DELETE', headers: getAuthHeaders() });

// Members
export const listMembers = () => request('/members');
export const getMember = (id) => request(`/members/${id}`);
export const createMember = (data) => request('/members', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const updateMember = (id, data) => request(`/members/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const deleteMember = (id) => request(`/members/${id}`, { method: 'DELETE', headers: getAuthHeaders() });

// Partners
export const listPartners = () => request('/partners');
export const getPartner = (id) => request(`/partners/${id}`);
export const createPartner = (data) => request('/partners', { method: 'POST', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const updatePartner = (id, data) => request(`/partners/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...getAuthHeaders() }, body: JSON.stringify(data) });
export const deletePartner = (id) => request(`/partners/${id}`, { method: 'DELETE', headers: getAuthHeaders() });
